import { AccuracyTemplateInspectionGroup } from "@app/templates/accuracy/models";

export function filterProviderClaimsActivityInspectionGroup(inspectionGroups: AccuracyTemplateInspectionGroup[], hideProviderClaimsActivity: boolean) : AccuracyTemplateInspectionGroup[] {
    if (hideProviderClaimsActivity) {
      const filteredInspectionGroups = inspectionGroups.map((group) => {
        if(group.name === 'Integrity'){
          const filteredInspection = group.inspections.filter((inspection) => inspection.name !== 'Provider Claims Activity');
          return {...group, inspections: filteredInspection}
        }
          return group;
      });
      return filteredInspectionGroups;
    }
    return inspectionGroups;
  }